import styled from 'styled-components';
import Link from '../../components/Link';
import ButtonLink from '../../components/Link/StyledLink';
import Search from '../../components/Search';

export const Root = styled.div`
	padding-top: 50px;
	color: ${({ theme }) => theme.primaryBlackColor};
	${({ theme }) => theme.typography.textM};

	@media (max-width: 992px) {
		padding-top: 10px;
	}
`;

export const Container = styled.div`
	max-width: 1400px;
	margin: 0 auto;

	@media (max-width: 1430px) {
		max-width: 100%;
		width: 100%;
		box-sizing: border-box;
		margin: 0 auto;
		padding-left: 15px;
		padding-right: 15px;
	}
`;

export const Header = styled.header`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 40px;

	@media (max-width: 768px) {
		flex-direction: column;
		align-items: flex-start;
	}
`;

export const Title = styled.h1`
	margin: 0;
	color: #000;
	${({ theme }) => theme.typography.headlineXXL};

	@media (max-width: 768px) {
		${({ theme }) => theme.typography.headlineXXLmobile};
	}
`;

export const SearchWrapper = styled.div`
	width: 30%;

	@media (max-width: 768px) {
		width: 100%;
	}
`;

export const SearchPanel = styled(Search)`
	input {
		padding-left: 0;
		border-top: none;
		border-right: none;
		border-left: none;
	}
`;

export const Section = styled.section`
	padding: 40px 0;
`;

export const SectionDark = styled(Section)`
	background-color: ${({ theme }) => theme.lightGrayColor};
`;

export const Subtitle = styled.h2`
	margin: 0 0 36px;
	${({ theme }) => theme.typography.headlineXL};

	@media (max-width: 768px) {
		margin: 0 0 24px;
		${({ theme }) => theme.typography.headlineXLmobile};
	}
`;

export const SubtitleLink = styled(Link)`
	color: ${({ theme }) => theme.primaryBlackColor};
	text-decoration: none;

	&:hover,
	&:active {
		color: ${({ theme }) => theme.primaryColor};
	}
`;

export const SectionTitle = styled.h2`
	margin-bottom: 35px;
	${({ theme }) => theme.typography.textBoldL};

	a {
		color: ${({ theme }) => theme.primaryBlackColor};
		text-decoration: none;
		transition: color 0.3s;

		&:hover {
			color: ${({ theme }) => theme.primaryColor};
		}
	}
`;

export const LoadMoreLink = styled(Link)`
	font-size: 16px;
	color: ${({ theme }) => theme.primaryBlackColor};
`;

export const List = styled.div`
	margin-bottom: 10px;
`;

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	padding: 50px 0 0;
`;

export const StyledButtonLink = styled(ButtonLink)`
	font-weight: 300;
	border-radius: 24px;
`;
